<p>financialdetails works!</p>
